import { Flex, Loader } from "@mantine/core";
import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import back from "../../assets/back.svg";
import ApplyModal from "../../components/ApplyModal";
import Button from "../../components/Button";
import Page from "../../components/Page";
import { backendUrl } from "../../constants";
import "./styles.css";

const Index = ({}) => {
  let userData = JSON.parse(localStorage.getItem("userData"));
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [opened, setOpened] = useState(false);
  const [applyData, setApplyData] = useState({
    user: userData.id,
  });
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [applied, setApplied] = useState(false);

  useEffect(() => {
    data &&
      data.appliedCandidates?.map((obj) => {
        if (obj.user._id === userData.id) {
          console.log("found", userData.id, obj.user);
          setApplied(true);
          return 1;
        }
      });
  }, [data, userData.id]);

  //get job data
  useEffect(() => {
    const options = {
      method: "GET",
    };
    setLoading(true);
    fetch(`${backendUrl}job/listSingleJob/${jobId}`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          setData(response?.data[0]);
          setLoading(false);
          setApplyData((v) => ({ ...v, jobId: response?.data[0]._id }));
        });
      })
      .catch((err) => console.error(err));
  }, [jobId]);

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      {data._id && (
        <ApplyModal
          opened={opened}
          setOpened={setOpened}
          jobId={data._id}
          setApplied={setApplied}
        />
      )}
      {loading ? (
        <div style={{ height: "50vh" }} className="d-flex align-items-center">
          <Loader size={"xl"} className="w-100 text-center" color={"red"} />
        </div>
      ) : (
        <div className="view-job-main">
          <div>
            <a className="backB" onClick={() => navigate(-1)}>
              <img src={back} width="15px" />
              Back
            </a>
          </div>
          <div className="view-job shadow-sm">
            <Flex justify={"space-between"}>
              <h2 className="text-dark">{data?.jobTitle}</h2>
              {userData?.role === "JobSeeker" && (
              <Button
                title={applied ? "Already Applied" : "Apply Now"}
                disable={applied}
                primary={true}
                fontWeight="700"
                onClick={(e) => setOpened(true)}
              />
              )}
            </Flex>
            <a href="/" style={{ textDecoration: "none" }}>
              {data?.createdBy?.companyProfileInfo[0]?.companyName ||
                "Company Name Here"}
            </a>
            <h6 style={{ color: "rgb(0,0,0,0.6)" }}>
              {data?.empLocation?.locationName + ", " + data?.empLocation?.city}
            </h6>
            <hr />
            {/* <div> */}
            <h5 style={{ color: "rgb(0,0,0,0.7)", fontWeight: "700" }}>
              Job Details
            </h5>
            <h6
              style={{
                color: "rgb(0,0,0,0.7)",
                fontWeight: "700",
                marginBottom: "0px",
              }}
            >
              Salary
            </h6>
            <p>
              ${data?.minSalary} - ${data?.maxSalary} per{" "}
              {data?.salaryRange === "monthly" ? "Month" : "Hour"}
            </p>
            <h6
              style={{
                color: "rgb(0,0,0,0.7)",
                fontWeight: "700",
                marginBottom: "0px",
              }}
            >
              Job Type
            </h6>
            <p>{data?.jobType?.map((type) => type?.jobType.lookupName)}</p>
            <h6
              style={{
                color: "rgb(0,0,0,0.7)",
                fontWeight: "700",
                marginBottom: "0px",
              }}
            >
              Job Industries
            </h6>
            <p>
              {data?.industries
                ?.map((ind) => ind?.industry?.industryName)
                .join(", ")}
            </p>
            <hr />
            <h5 style={{ color: "rgb(0,0,0,0.7)", fontWeight: "700" }}>
              Job Qualifications
            </h5>
            <h6
              style={{
                color: "rgb(0,0,0,0.7)",
                fontWeight: "700",
                marginBottom: "0px",
              }}
            >
              Required Job Skills
            </h6>
            <p>
              {data?.skills?.map((skill) => skill.skills.skillName).join(", ")}
            </p>
            <h6
              style={{
                color: "rgb(0,0,0,0.7)",
                fontWeight: "700",
                marginBottom: "0px",
              }}
            >
              Education
            </h6>
            <p>{data?.education?.lookupName}</p>
            <hr />
            <h5 style={{ color: "rgb(0,0,0,0.7)", fontWeight: "700" }}>
              Job Description
            </h5>
            <p>{data?.jobDescription}</p>
            {/* </div> */}
          </div>
        </div>
      )}
    </Page>
  );
};

export default withTranslation()(Index);
